import { ResponsiveSankey } from '@nivo/sankey'

const LABEL_PADDING = 16
const LINE_HEIGHT = 16
const LEFT_NODE_X_THRESHOLD = 250
const BASELINE_OFFSET = 12
const LINE_BREAK = '__BR__'
const PRIMARY_LABEL_STYLE = { fill: '#292424', fontSize: 14 }
const SECONDARY_LABEL_STYLE = { fill: '#6b7280', fontSize: 12 }

/** Renders multi-line labels (split by __BR__) as a custom Sankey layer. */
function MultiLineLabelsLayer({ nodes, width }) {
  return (
    <g>
      {nodes.map((node) => {
        const labelText = node.label || node.id || ''
        const lines = String(labelText).split(LINE_BREAK).map((s) => s.trim()).filter(Boolean)
        if (lines.length === 0) return null
        const nodeWidth = node.width ?? 0
        const nodeHeight = node.height ?? 35
        const isLeft = node.x < LEFT_NODE_X_THRESHOLD
        const textX = isLeft ? -LABEL_PADDING : nodeWidth + LABEL_PADDING
        const textAnchor = isLeft ? 'end' : 'start'
        const totalLabelHeight = lines.length * LINE_HEIGHT
        const startY = Math.max(0, (nodeHeight - totalLabelHeight) / 2) + BASELINE_OFFSET

        return (
          <g key={node.id} transform={`translate(${node.x}, ${node.y})`}>
            {lines.map((line, index) => (
              <text
                key={index}
                x={textX}
                y={startY + index * LINE_HEIGHT}
                textAnchor={textAnchor}
                style={index === 0 ? PRIMARY_LABEL_STYLE : SECONDARY_LABEL_STYLE}
              >
                {line}
              </text>
            ))}
          </g>
        )
      })}
    </g>
  )
}

const UtilizationSankeyChart = ({ sankeyData, height, classes = '' }) => {
  const { data, colors } = sankeyData

  const customLabelsLayer = (ctx) => (
    <MultiLineLabelsLayer nodes={ctx.nodes} width={ctx.width} />
  )

  return (
    <div className={classes} style={{ height, overflow: 'visible' }}>
      <ResponsiveSankey
        data={data}
        margin={{ top: 0, right: 240, bottom: 20, left: 230 }}
        align="justify"
        colors={colors}
        nodeOpacity={1}
        nodeThickness={35}
        nodeSpacing={32}
        nodeBorderWidth={0}
        nodeHoverOthersOpacity={0.35}
        linkOpacity={0.2}
        linkHoverOpacity={1}
        linkHoverOthersOpacity={0.1}
        linkContract={0.3}
        enableLabels={false}
        layers={['links', 'nodes', customLabelsLayer, 'legends']}
        nodeBorderColor={{ from: 'color', modifiers: [['darker', 0.8]] }}
        enableLinkGradient
        theme={{
          fontName: 'ProximaNova',
          fontSize: 14
        }}
        nodeTooltip={(node) => {
          return (
            <div style={{ padding: '5px', backgroundColor: 'white', border: '1px solid black' }}>
              <strong>
                {node.node.id}
              </strong>
              <br />
              <strong>
                {node.node.amount}
              </strong>
            </div>
          );
        }}
        label={(node) => (node.node && node.node.id) || node.id || ''}
        linkTooltip={(link) => {
          return (
            <div style={{ padding: '5px', backgroundColor: 'white', border: '1px solid black', display: 'flex', gap: '10px' }}>
              <div>
                {link.link.source.id}<br />{link.link.source.amount}
              </div>
              ➔
              <div>
                {link.link.target.id}<br />{link.link.target.amount}
              </div>
            </div>);
        }}
      />
    </div>
  );
}

export default UtilizationSankeyChart
